import MenuItem from '@mui/material/MenuItem';
import React from 'react';

import {
  StatusOptionDesc,
  StatusOptionDot,
  StatusOptionLabel,
  StatusOptionRow,
  StatusOptionTextStack,
} from './StatusSelect.styles';

export type EntityStatus = 'Active' | 'OnHold' | 'Inactive';

interface StatusConfig {
  label: string;
  dot: string;
  desc: string;
}

export const STATUS_CONFIG: Record<EntityStatus, StatusConfig> = {
  Active:   { label: 'Active',   dot: '#22c55e', desc: 'Visible and accessible' },
  OnHold:   { label: 'On Hold',  dot: '#f59e0b', desc: 'Paused — work temporarily stopped' },
  Inactive: { label: 'Inactive', dot: '#94a3b8', desc: 'Deactivated — hidden from active views' },
};

export const STATUS_OPTIONS: EntityStatus[] = ['Active', 'OnHold', 'Inactive'];

export const StatusOption: React.FC<{ value: string }> = ({ value }) => {
  const cfg = STATUS_CONFIG[value as EntityStatus];
  if (!cfg) return null;
  return (
    <StatusOptionRow>
      <StatusOptionDot dotcolor={cfg.dot} />
      <StatusOptionTextStack>
        <StatusOptionLabel>{cfg.label}</StatusOptionLabel>
        <StatusOptionDesc>{cfg.desc}</StatusOptionDesc>
      </StatusOptionTextStack>
    </StatusOptionRow>
  );
};

export const statusMenuItems = (menuItemSx?: object) =>
  STATUS_OPTIONS.map((s) => (
    <MenuItem key={s} value={s} sx={menuItemSx}>
      <StatusOption value={s} />
    </MenuItem>
  ));
